"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8977],{

/***/ 68977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Header; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/gsap/index.js + 1 modules
var gsap = __webpack_require__(10990);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/GetStarted/GetStarted.tsx




var GetStarted = function(param) {
    var isWhite = param.isWhite, isActiveOverlay = param.isActiveOverlay;
    var OnLoadTimeline = gsap/* default.timeline */.ZP.timeline({
        defaults: {
            duration: 1.4
        }
    });
    (0,react.useEffect)(function() {
        OnLoadTimeline.to("._headerGetStarted", {
            y: 0,
            opacity: 1
        }, "start");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: "/contact-us",
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "#",
                "aria-label": "Contact us page",
                className: "\n                ".concat(isWhite ? "text-white hover:text-white hover:opacity-80 duration-300" : "text-[#131313] hover:text-primary", "  lg:flex items-center hidden h-[70px]\n                 text-[.85714rem] font-bold uppercase absolute right-32 z-[9997]  cursor-pointer transition ease-in-out duration-300 z-1 w-max"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "opacity-0 -translate-y-6 _headerGetStarted",
                    children: "WORK WITH US"
                })
            })
        })
    });
};
/* harmony default export */ var GetStarted_GetStarted = (GetStarted);

;// CONCATENATED MODULE: ./src/components/WhiteAnnimeLogo/WhiteAnnimeLogo.tsx

var WhiteAnnimeLogo = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            id: "dg-logo-white",
            className: "max-w-[90vw] max-h-[90vh] w-[340px]",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 4234 843",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                            id: "clip-letters",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                x: "623.32",
                                width: "3300",
                                height: "843",
                                fill: "#fff"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                            id: "clip-d",
                            x: "230.24",
                            y: "193.34",
                            width: "3795.05",
                            height: "426.64",
                            maskUnits: "userSpaceOnUse",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                                id: "d-mask",
                                points: "4025.29 193.34 4025.29 524.8 3930.11 524.8 3930.11 619.98 230.24 619.98 230.24 193.34 4025.29 193.34",
                                fill: "#fff"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    id: "hiding-rect",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        clipPath: "url(#clip-letters)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            id: "letters",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    id: "let-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M709.36,285.68c30.78,0,51.48-20.16,51.48-47.76,0-25.47-20.7-44.58-51.48-44.58s-51.48,20.17-51.48,46.17S678.58,285.68,709.36,285.68Z",
                                            fill: "#fff"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                            x: "667.96",
                                            y: "325.48",
                                            width: "82.79",
                                            height: "285.52",
                                            fill: "#fff"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "let-2",
                                    d: "M1043.58,325.48V362.1c-21.76-27.59-54.66-40.86-94.46-40.86-79.08,0-142.76,54.66-142.76,138s63.68,138,142.76,138c37.15,0,68.46-11.67,90.21-35.55v12.2c0,51.48-25.47,78-83.85,78-36.61,0-76.42-12.73-100.83-32.37l-32.9,59.44c33.43,26,86,39.27,140.1,39.27,103,0,160.27-48.82,160.27-155V325.48Zm-78,203.79c-43.52,0-75.36-28.12-75.36-70s31.84-70.05,75.36-70.05,74.83,28.13,74.83,70.05S1009.09,529.27,965.57,529.27Z",
                                    fill: "#fff"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    id: "let-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M1240.57,285.68c30.78,0,51.48-20.16,51.48-47.76,0-25.47-20.7-44.58-51.48-44.58s-51.47,20.17-51.47,46.17S1209.79,285.68,1240.57,285.68Z",
                                            fill: "#fff"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                            x: "1199.18",
                                            y: "325.48",
                                            width: "82.79",
                                            height: "285.52",
                                            fill: "#fff"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "let-4",
                                    d: "M1520.66,538.83c-9,6.89-21.22,10.61-33.43,10.61-22.29,0-35.56-13.27-35.56-37.68V395.54h71.12V331.85h-71.12V262.33h-82.78v69.52h-44.05v63.69h44.05V512.82c0,67.93,39.27,102.43,106.67,102.43,25.47,0,50.41-5.84,67.39-18Z",
                                    fill: "#fff"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "let-5",
                                    d: "M1704.59,321.24c-45.64,0-91.81,12.21-123.12,34.49l29.72,57.85c20.69-16.45,52-26.53,82.25-26.53,44.58,0,65.81,20.69,65.81,56.25h-65.81c-87,0-122.59,35-122.59,85.44,0,49.36,39.8,86.51,106.67,86.51,41.93,0,71.65-13.8,87-39.81V611H1842V448.08C1842,361.57,1791.62,321.24,1704.59,321.24Zm54.66,199.54c-9.55,26-33.43,38.74-61,38.74-29.19,0-46.7-13.8-46.7-34.49,0-19.11,12.2-33.44,51-33.44h56.78Z",
                                    fill: "#fff"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                    id: "let-6",
                                    x: "1916.97",
                                    y: "217.22",
                                    width: "82.79",
                                    height: "393.78",
                                    fill: "#fff"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "let-7",
                                    d: "M2483.74,528.21c-21.76,11.68-43.51,15.92-66.87,15.92-71.11,0-120.46-49.35-120.46-118.87,0-70.59,49.35-118.88,121.53-118.88,37.68,0,69,13.27,96,41.92l55.19-50.94c-36.08-41.93-90.21-64.22-155.49-64.22-118.35,0-204.32,80.14-204.32,192.12s86,192.11,202.73,192.11c53.07,0,109.32-16.45,150.19-47.23V419.42h-78.55Z",
                                    fill: "#fff"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "let-8",
                                    d: "M2715.38,363.17V325.48h-79.07V611h82.79V476.2c0-54.66,30.25-79.6,75.89-79.6,6.37,0,11.67.53,18.57,1.06V321.24C2769.51,321.24,2735.55,335.57,2715.38,363.17Z",
                                    fill: "#fff"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "let-9",
                                    d: "M3139.87,469.3c0-91.81-64.74-148.06-148.59-148.06-87,0-152.31,61.56-152.31,147,0,84.91,64.21,147,162.92,147,51.48,0,91.28-15.92,117.82-46.17l-44.05-47.77c-19.64,18.58-41.39,27.6-71.64,27.6-43.52,0-73.77-21.76-81.73-57.32h216C3138.81,484.69,3139.87,475.67,3139.87,469.3Zm-218.64-26c5.83-36.62,32.9-59.44,70.58-59.44,37.15,0,64.21,23.35,70.05,59.44Z",
                                    fill: "#fff"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "let-10",
                                    d: "M3411,325.48V362.1c-21.76-27.59-54.67-40.86-94.47-40.86-79.07,0-142.76,54.66-142.76,138s63.69,138,142.76,138c37.15,0,68.46-11.67,90.22-35.55v12.2c0,51.48-25.47,78-83.85,78-36.62,0-76.42-12.73-100.83-32.37l-32.91,59.44c33.44,26,86,39.27,140.11,39.27,102.95,0,160.27-48.82,160.27-155V325.48Zm-78,203.79c-43.51,0-75.36-28.12-75.36-70s31.85-70.05,75.36-70.05,74.83,28.13,74.83,70.05S3376.49,529.27,3333,529.27Z",
                                    fill: "#fff"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "let-11",
                                    d: "M3782.58,325.48V362.1c-21.76-27.59-54.66-40.86-94.47-40.86-79.07,0-142.75,54.66-142.75,138s63.68,138,142.75,138c37.15,0,68.46-11.67,90.22-35.55v12.2c0,51.48-25.47,78-83.85,78-36.62,0-76.42-12.73-100.83-32.37l-32.9,59.44c33.43,26,86,39.27,140.1,39.27,103,0,160.27-48.82,160.27-155V325.48Zm-78,203.79c-43.51,0-75.35-28.12-75.35-70s31.84-70.05,75.35-70.05,74.83,28.13,74.83,70.05S3748.08,529.27,3704.56,529.27Z",
                                    fill: "#fff"
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    id: "hiding-d",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        clipPath: "url(#clip-d)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            id: "main-letter",
                            d: "M230.24,610.66H407.8c127.86,0,215.52-77.8,215.52-197.33S535.66,216,407.8,216H314.13v82.22H230.24Zm172-312.44c77.61,0,129.54,39.56,129.54,115.11S480.94,535.68,403.33,535.68l-89.2,1V298.22Z",
                            fill: "#fff",
                            fillRule: "evenodd"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    id: "logo-dot",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M3938.7,533.39h78v78h-78Z",
                        fill: "#fff"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var WhiteAnnimeLogo_WhiteAnnimeLogo = (WhiteAnnimeLogo);

;// CONCATENATED MODULE: ./src/hooks/useScroll.tsx

function useScrollListener() {
    var ref = (0,react.useState)({
        x: 0,
        y: 0,
        lastX: 0,
        lastY: 0
    }), data = ref[0], setData = ref[1];
    // set up event listeners
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            setData(function(last) {
                return {
                    x: window.scrollX,
                    y: window.scrollY,
                    lastX: last.x,
                    lastY: last.y
                };
            });
        };
        handleScroll();
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return data;
};

// EXTERNAL MODULE: ./src/hooks/useWindowDimensions.tsx
var useWindowDimensions = __webpack_require__(98166);
// EXTERNAL MODULE: ./src/state/index.tsx
var state = __webpack_require__(9417);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/jotai/esm/index.js
var esm = __webpack_require__(91131);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-lazy-load/dist/LazyLoad.js
var LazyLoad = __webpack_require__(25043);
// EXTERNAL MODULE: ./src/constant/index.tsx + 38 modules
var constant = __webpack_require__(17089);
// EXTERNAL MODULE: ./src/icons/Logos/BlackMainLogo.tsx
var BlackMainLogo = __webpack_require__(99947);
;// CONCATENATED MODULE: ./src/icons/Logos/WhiteLogo.tsx


var WhiteLogo = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "100%",
        height: "100%",
        viewBox: "0 0 393 395",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M177.335 395H0.0418597L0 82.2647H82.2339L82.7798 320.813L172.826 319.846C251.176 319.846 302.47 272.946 302.47 197.226C302.47 121.508 250.049 81.8593 171.698 81.8593L82.2339 82.2647V0H129.566H177.376C306.456 0 393 77.7361 393 197.53C393 240.701 381.755 278.402 361.328 308.97H307.033L306.941 361.3C272.05 383.052 227.961 395 177.335 395Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M393 395V319H317V395H393Z",
                fill: "white"
            })
        ]
    });
};
/* harmony default export */ var Logos_WhiteLogo = (WhiteLogo);

;// CONCATENATED MODULE: ./src/icons/Logos/WhiteLongWhiteDot.tsx


var WhiteLongWhiteDot = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "100%",
        height: "40px",
        viewBox: "0 0 1736 295",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M209.135 85.1286C223.126 85.1286 232.534 75.962 232.534 63.4182C232.534 51.8394 223.126 43.1553 209.135 43.1553C195.144 43.1553 185.736 52.3219 185.736 64.1419C185.736 75.962 195.144 85.1286 209.135 85.1286ZM190.319 233H227.951V103.22H190.319V233ZM361.055 103.22V119.865C351.164 107.321 336.208 101.291 318.116 101.291C282.174 101.291 253.227 126.137 253.227 164.009C253.227 201.882 282.174 226.728 318.116 226.728C335.002 226.728 349.234 221.421 359.125 210.566V216.114C359.125 239.513 347.546 251.574 321.011 251.574C304.366 251.574 286.275 245.785 275.178 236.86L260.222 263.877C275.419 275.697 299.301 281.728 323.906 281.728C370.704 281.728 396.756 259.535 396.756 211.29V103.22H361.055ZM325.594 195.851C305.814 195.851 291.34 183.066 291.34 164.009C291.34 144.953 305.814 132.168 325.594 132.168C345.375 132.168 359.607 144.953 359.607 164.009C359.607 183.066 345.375 195.851 325.594 195.851ZM450.596 85.1286C464.588 85.1286 473.995 75.962 473.995 63.4182C473.995 51.8394 464.588 43.1553 450.596 43.1553C436.605 43.1553 427.198 52.3219 427.198 64.1419C427.198 75.962 436.605 85.1286 450.596 85.1286ZM431.781 233H469.412V103.22H431.781V233ZM577.911 200.193C573.81 203.329 568.262 205.018 562.714 205.018C552.582 205.018 546.552 198.987 546.552 187.891V135.062H578.876V106.115H546.552V74.5146H508.92V106.115H488.899V135.062H508.92V188.373C508.92 219.25 526.771 234.93 557.407 234.93C568.986 234.93 580.323 232.276 588.042 226.728L577.911 200.193ZM661.513 101.291C640.767 101.291 619.781 106.839 605.548 116.97L619.057 143.264C628.465 135.786 642.697 131.203 656.447 131.203C676.71 131.203 686.359 140.611 686.359 156.773H656.447C616.886 156.773 600.724 172.694 600.724 195.61C600.724 218.044 618.816 234.93 649.21 234.93C668.267 234.93 681.776 228.658 688.771 216.838V233H723.99V158.944C723.99 119.624 701.074 101.291 661.513 101.291ZM658.618 209.601C645.35 209.601 637.39 203.329 637.39 193.921C637.39 185.237 642.938 178.724 660.548 178.724H686.359V191.992C682.017 203.812 671.162 209.601 658.618 209.601ZM758.048 233H795.679V54.0104H758.048V233ZM1015.67 195.369C1005.78 200.676 995.893 202.606 985.279 202.606C952.955 202.606 930.521 180.172 930.521 148.571C930.521 116.488 952.955 94.5364 985.762 94.5364C1002.89 94.5364 1017.12 100.567 1029.42 113.593L1054.51 90.4355C1038.11 71.3787 1013.5 61.2472 983.832 61.2472C930.038 61.2472 890.96 97.6723 890.96 148.571C890.96 199.47 930.038 235.895 983.108 235.895C1007.23 235.895 1032.8 228.417 1051.37 214.426V145.917H1015.67V195.369ZM1120.96 120.348V103.22H1085.02V233H1122.65V171.729C1122.65 146.882 1136.4 135.545 1157.15 135.545C1160.04 135.545 1162.46 135.786 1165.59 136.027V101.291C1145.57 101.291 1130.13 107.804 1120.96 120.348ZM1313.92 168.593C1313.92 126.861 1284.49 101.291 1246.37 101.291C1206.81 101.291 1177.14 129.273 1177.14 168.11C1177.14 206.706 1206.33 234.93 1251.2 234.93C1274.6 234.93 1292.69 227.693 1304.75 213.943L1284.73 192.233C1275.8 200.676 1265.91 204.777 1252.16 204.777C1232.38 204.777 1218.63 194.886 1215.01 178.724H1313.19C1313.43 175.588 1313.92 171.487 1313.92 168.593ZM1246.61 129.755C1263.5 129.755 1275.8 140.369 1278.46 156.773H1214.53C1217.18 140.128 1229.49 129.755 1246.61 129.755ZM1437.15 103.22V119.865C1427.26 107.321 1412.3 101.291 1394.21 101.291C1358.27 101.291 1329.32 126.137 1329.32 164.009C1329.32 201.882 1358.27 226.728 1394.21 226.728C1411.1 226.728 1425.33 221.421 1435.22 210.566V216.114C1435.22 239.513 1423.64 251.574 1397.1 251.574C1380.46 251.574 1362.37 245.785 1351.27 236.86L1336.32 263.877C1351.51 275.697 1375.39 281.728 1400 281.728C1446.8 281.728 1472.85 259.535 1472.85 211.29V103.22H1437.15ZM1401.69 195.851C1381.91 195.851 1367.43 183.066 1367.43 164.009C1367.43 144.953 1381.91 132.168 1401.69 132.168C1421.47 132.168 1435.7 144.953 1435.7 164.009C1435.7 183.066 1421.47 195.851 1401.69 195.851ZM1606.05 103.22V119.865C1596.16 107.321 1581.21 101.291 1563.11 101.291C1527.17 101.291 1498.23 126.137 1498.23 164.009C1498.23 201.882 1527.17 226.728 1563.11 226.728C1580 226.728 1594.23 221.421 1604.12 210.566V216.114C1604.12 239.513 1592.54 251.574 1566.01 251.574C1549.36 251.574 1531.27 245.785 1520.18 236.86L1505.22 263.877C1520.42 275.697 1544.3 281.728 1568.9 281.728C1615.7 281.728 1641.75 259.535 1641.75 211.29V103.22H1606.05ZM1570.59 195.851C1550.81 195.851 1536.34 183.066 1536.34 164.009C1536.34 144.953 1550.81 132.168 1570.59 132.168C1590.37 132.168 1604.61 144.953 1604.61 164.009C1604.61 183.066 1590.37 195.851 1570.59 195.851ZM1676.9 197.9H1712.59V233H1676.9V197.9Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0 232.937H76.585C131.736 232.937 169.547 199.632 169.547 148.469C169.547 97.3048 131.736 64 76.585 64H36.1854V99.1952H0V232.937ZM74.1766 99.1952C107.652 99.1952 130.05 116.129 130.05 148.469C130.05 180.808 108.134 200.839 74.6583 200.839L36.1854 201.252V99.1952H74.1766Z",
                fill: "white"
            })
        ]
    });
};
/* harmony default export */ var Logos_WhiteLongWhiteDot = (WhiteLongWhiteDot);

// EXTERNAL MODULE: ./public/imgs/lotties/heart-lootie.json
var heart_lootie = __webpack_require__(8042);
// EXTERNAL MODULE: ./public/imgs/lotties/message-lottie.json
var message_lottie = __webpack_require__(3971);
// EXTERNAL MODULE: ./public/imgs/lotties/telephone-lootie.json
var telephone_lootie = __webpack_require__(62674);
;// CONCATENATED MODULE: ./src/components/Header/Header.tsx
/* eslint-disable @next/next/no-img-element */ 





















var Lottie = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(296), __webpack_require__.e(9185)]).then(__webpack_require__.bind(__webpack_require__, 69185));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69185)
            ];
        }
    }
});
var MobileRequestEstimate = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2044).then(__webpack_require__.bind(__webpack_require__, 42044));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(42044)
            ];
        }
    }
});
var OverlaySocials = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3138).then(__webpack_require__.bind(__webpack_require__, 33138));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(33138)
            ];
        }
    }
});
var MobileSocials = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8391).then(__webpack_require__.bind(__webpack_require__, 88391));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(88391)
            ];
        }
    }
});
function PlaygroundNav() {
    var handleClick = // Normal Functions
    function handleClick() {
        setShowOverlay(function(prev) {
            return !prev;
        });
        setActiveNav(function(prev) {
            return !prev;
        });
    };
    var closeNavOnMenuClick = function closeNavOnMenuClick() {
        setActiveNav(false);
        setShowOverlay(false);
    };
    var OnLoadTimeline = gsap/* default.timeline */.ZP.timeline({
        defaults: {
            duration: 1.4
        }
    });
    // States
    var ref = (0,react.useState)(false), activeNav = ref[0], setActiveNav = ref[1];
    var ref1 = (0,react.useState)(false), showOverlay = ref1[0], setShowOverlay = ref1[1];
    var ref2 = (0,react.useState)(undefined), overlayActive = ref2[0], setOverlayActive = ref2[1];
    var ref3 = (0,react.useState)(false), telPlay = ref3[0], setTelPlay = ref3[1];
    var ref4 = (0,react.useState)(false), getInplay = ref4[0], setGetInPlay = ref4[1];
    var ref5 = (0,react.useState)(false), mailPlay = ref5[0], setMailPlay = ref5[1];
    var ref6 = (0,react.useState)(false), changeLogo = ref6[0], setChangeLogo = ref6[1];
    var ref7 = (0,react.useState)(false), showNav = ref7[0], setShowNav = ref7[1];
    var scroll = useScrollListener();
    var router = (0,next_router.useRouter)();
    var encEmail = "Z3JlZ2dAZGlnaXRhbGdyZWdnLmNvbQ==";
    var encMobile = "Kzg4MDE4NTEtNTkwNjk0";
    var width = (0,useWindowDimensions/* default */.Z)().width;
    var isBlogPage = router.pathname === "/insights";
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(state/* videoModalOpen */.Rs), 2), videoModalIsOpen = ref8[0], setVideoModalIsOpen = ref8[1];
    // useLockBodyScroll(showOverlay);
    (0,react.useEffect)(function() {
        OnLoadTimeline.to("._headerNavigationMenu", {
            x: 0,
            delay: 0.2
        }, "start").to("._headerLogo", {
            x: 0
        }, "start");
    }, []);
    // Use Effects
    (0,react.useEffect)(function() {
        var ref, ref1;
        showOverlay ? (ref = document.querySelector("body")) === null || ref === void 0 ? void 0 : ref.classList.add("overflow-hidden") : (ref1 = document.querySelector("body")) === null || ref1 === void 0 ? void 0 : ref1.classList.remove("overflow-hidden");
        if (showOverlay) {
            setTimeout(function() {
                setChangeLogo(true);
            }, 1000);
        } else {
            setChangeLogo(false);
            setTimeout(function() {
                setChangeLogo(false);
            }, 1000);
        }
    }, [
        showOverlay
    ]);
    // update classList of nav on scroll
    (0,react.useEffect)(function() {
        setShowNav(false);
        if (window.scrollY > 250 && scroll.y - scroll.lastY > 0) setShowNav(true);
    // setNavClassList(_classList);
    }, [
        scroll.y,
        scroll.lastY
    ]);
    var sendMail = function() {
        router.push("mailto:".concat(atob(encEmail)));
    };
    var sendPhone = function() {
        router.push("tel:".concat(atob(encMobile)));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "TopLogo",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "#",
                        "aria-label": "home page",
                        onClick: function() {
                            closeNavOnMenuClick();
                            setOverlayActive(undefined);
                        },
                        className: "h-[70px] fixed top-0 left-0 -translate-x-[70px] z-[998] aspect-square flex items-center justify-center _headerLogo",
                        children: changeLogo ? width >= 1024 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(WhiteAnnimeLogo_WhiteAnnimeLogo, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "".concat(showNav ? "opacity-0 lg:opacity-100 duration-[1.35s] lg:block top-0" : "opacity-1 duration-[1.35s] lg:block top-0", " relative z-[999] w-[32px] md:w-[2.3rem]"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logos_WhiteLogo, {})
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "".concat(showNav ? "opacity-0 lg:opacity-100 duration-[1.35s]  lg:block top-0" : "opacity-1 duration-[1.35s] lg:block top-0", " relative z-[999]"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlackMainLogo/* default */.Z, {})
                                }),
                                showOverlay ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()("absolute inset-0 bg-redblack w-full h-full", showOverlay ? "-translate-x-full duration-[700ms] delay-[600ms] md:delay-[830ms]" : "translate-x-0 duration-[200ms]")
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()("absolute", showNav ? "-translate-x-20 lg:translate-x-0 duration-700  lg:block top-0 z-[1] absolute inset-0 bg-redblack w-full h-full" : "translate-x-0 opacity-1 duration-700 lg:block top-0 z-[1] absolute inset-0 bg-redblack w-full h-full")
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "group ".concat(showNav ? "" : "z-[998]", " lg:z-[998] fixed top-0 right-0 _headerNavigationMenu translate-x-[70px] ").concat(videoModalIsOpen ? "invisible" : "visible"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: classnames_default()("group cursor-pointer h-[70px] z-[998] w-[70px] flex items-center justify-center", showOverlay ? "bg-transparent" : "bg-primary", showNav ? "translate-x-20 lg:translate-x-0 duration-700 sticky top-0 z-10" : "translate-x-0 opacity-1 duration-700 sticky top-0 z-10"),
                    onClick: handleClick,
                    id: "header",
                    "aria-label": "Menu Button",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative w-5 h-3.5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: classnames_default()("absolute top-0 left-0 h-0.5 w-full inline-block bg-white -translate-x-1 duration-[400ms] ease-out group-hover:translate-x-0 group-focus:!translate-x-0", activeNav && "translate-x-0 !top-1/2 -translate-y-1/2 rotate-45")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: classnames_default()("absolute top-1/2 -translate-y-1/2 left-0 h-0.5 w-full inline-block bg-white translate-x-1 duration-[400ms] ease-out group-hover:translate-x-0 group-focus:translate-x-0", activeNav && "translate-x-0 opacity-0")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: classnames_default()("absolute bottom-0 left-0 h-0.5 w-full inline-block bg-white -translate-x-1 duration-[400ms] ease-out group-hover:translate-x-0 group-focus:translate-x-0", activeNav && "translate-x-0 !top-1/2 -translate-y-1/2 -rotate-45")
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("__navOverlayBg fixed h-screen w-[100%] z-[997]", showOverlay ? "".concat(isBlogPage ? "bg-gradient-to-r from-black/90 to-[#373839d6] " : "bg-gradient-to-r from-primary/90 to-primary/70", "  translate-x-0 duration-[1200ms] pointer-events-auto") : "".concat(isBlogPage ? "bg-gradient-to-r from-black/90 to-[#373839d6] " : "bg-gradient-to-r from-primary/90 to-primary/70", " translate-x-full duration-[900ms] pointer-events-none")),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileRequestEstimate, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-[calc(50%+52px)] sm:-translate-y-[calc(50%-10px)] md:-translate-y-[calc(50%-20px)] lg:grid lg:grid-cols-[200px,auto] lg:gap-[280px] 2xl:gap-[400px] 3xl:gap-[500px] __overlayGrid",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-full",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: "flex flex-col h-full items-center lg:items-start",
                                    children: [
                                        constant/* overlayData.map */.pB.map(function(param, i) {
                                            var text = param.text, url = param.url;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: url,
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    onClick: function() {
                                                        setOverlayActive(i);
                                                        closeNavOnMenuClick();
                                                    },
                                                    className: classnames_default()("menuItem group text-[1.57143rem] first:mt-0 sm:first:mt-[60px] md:first:mt-[90px] lg:first:mt-0 mb-[2rem] md:mb-[3rem] leading-[35px] md:text-[1.85714rem] md:leading-[1.57692em] text-white landscape:lg:mb-[3rem] landscape:mb-6 landscape:lg:first:mt-0 landscape:first:mt-6", showOverlay ? "translate-x-0 opacity-100 duration-700 __transitionDelay".concat(i, " ") : "-translate-x-40 opacity-0 duration-[400ms] delay-[0ms]"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "#",
                                                        "aria-label": "".concat(text, " page"),
                                                        className: classnames_default()("relative before:absolute before:bottom-0 before:left-[calc(100%+30px)] inline before:h-0.5 before:duration-300 transition-all before:bg-white lg:group-hover:before:w-20 cursor-pointer", overlayActive === i ? "lg:before:w-0" : "lg:before:w-0", router.pathname === url && "font-bold"),
                                                        children: text
                                                    })
                                                })
                                            }, "yrfgsd_" + i);
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "lg:hidden portrait:block landscape:hidden",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileSocials, {
                                                showOverlay: showOverlay
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()("space-y-5 text-white hidden lg:block", showOverlay ? "opacity-100 translate-x-0 delay-[1500ms] duration-700" : "opacity-0 translate-x-40 duration-[400ms]"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "relative mb-[24px] flex items-start",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logos_WhiteLongWhiteDot, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlaySocials, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: "space-y-2 -ml-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "flex items-center cursor-pointer -ml-1",
                                                onMouseEnter: function() {
                                                    return setTelPlay(true);
                                                },
                                                onMouseLeave: function() {
                                                    return setTelPlay(false);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    href: "#",
                                                    onClick: sendPhone,
                                                    className: "flex items-center gap-2",
                                                    "aria-label": "telephone page",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyLoad/* default */.Z, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Lottie, {
                                                                animationData: telephone_lootie,
                                                                play: telPlay,
                                                                speed: 0.5,
                                                                className: "w-[40px] h-[40px]",
                                                                color: "blue",
                                                                loop: telPlay
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "font-light",
                                                            children: "Call by Phone"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "flex items-center cursor-pointer",
                                                onMouseEnter: function() {
                                                    return setGetInPlay(true);
                                                },
                                                onMouseLeave: function() {
                                                    return setGetInPlay(false);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/request-estimate",
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                        href: "#",
                                                        className: "flex items-center gap-2",
                                                        "aria-label": "request estimate page",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyLoad/* default */.Z, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Lottie, {
                                                                    animationData: heart_lootie,
                                                                    play: getInplay,
                                                                    speed: 0.5,
                                                                    className: "w-[40px] h-[40px] text-white",
                                                                    loop: getInplay
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "font-light",
                                                                children: "Get Started"
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "flex items-center cursor-pointer",
                                                onMouseEnter: function() {
                                                    return setMailPlay(true);
                                                },
                                                onMouseLeave: function() {
                                                    return setMailPlay(false);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/contact-us",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                        href: "#",
                                                        className: "flex items-center gap-2 cursor-pointer",
                                                        onClick: function() {
                                                            return closeNavOnMenuClick();
                                                        },
                                                        "aria-label": "contact page",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyLoad/* default */.Z, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Lottie, {
                                                                    animationData: message_lottie,
                                                                    play: mailPlay,
                                                                    speed: 0.5,
                                                                    className: "w-[40px] h-[40px] text-white",
                                                                    loop: mailPlay
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "!text-white font-light",
                                                                children: "Message Us"
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            router.pathname === "/contact-us" ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat(showOverlay ? "sticky top-0" : "", " !z-[999]"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GetStarted_GetStarted, {
                    isWhite: router.pathname === "/about" || router.pathname === "/services" || router.pathname === "/_error" || router.pathname === "/insights" || showOverlay,
                    isActiveOverlay: showOverlay
                })
            })
        ]
    });
}
/* harmony default export */ var Header = (PlaygroundNav);

;// CONCATENATED MODULE: ./src/components/Header/index.tsx




/***/ }),

/***/ 99947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var BlackMainLogo = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "100%",
        height: "100%",
        viewBox: "0 0 843 843",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_1698_306)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M843 0H0V843H843V0Z",
                        fill: "#333333"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M402.335 619H225.042L225 306.265H307.234L307.78 544.813L397.826 543.846C476.176 543.846 527.47 496.946 527.47 421.226C527.47 345.508 475.049 305.859 396.698 305.859L307.234 306.265V224H354.566H402.376C531.456 224 618 301.736 618 421.53C618 464.701 606.755 502.402 586.328 532.97H532.033L531.941 585.3C497.05 607.052 452.961 619 402.335 619Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M618 619V543H542V619H618Z",
                        fill: "#C10206"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_1698_306",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "843",
                        height: "843",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BlackMainLogo);


/***/ })

}]);